import $ from 'jquery';
import { lenis } from './animations';

const loginForm = document.querySelector('#member-login-form');
const resetPassForm = document.querySelector("#ajax-reset-form");
const loginFormWrap = loginForm.closest('.member-login-form');
const resetPassFormWrap = resetPassForm.closest('.member-resetpass-form');

const observer = new MutationObserver(() => {
  const hasOpenModal = document.querySelector('.modal.modal-active');

  if (hasOpenModal) {
    lenis.stop();
  }
});

observer.observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ['class'],
});

const showModal = (modal) => {
  if (!modal.hasClass('modal-active')) {
    modal.fadeIn(800).addClass('modal-active');
  }
}

const closeModal = () => {
  const modal = $('.modal.modal-active');
  modal.fadeOut();
  modal.removeClass('modal-active');
  lenis.start();

  loginFormWrap && loginFormWrap.classList.remove('hide');
  resetPassFormWrap && resetPassFormWrap.classList.add('hide');

  if(modal.attr('id') === 'modal-submit-form') {
    window.location.href = themeVars.home;
  }
}

function triggerModal() {
  const now = new Date();
  const modalWelcom = $('.js-modal-welcome');

    $(document).on('mousedown', (e) => {
    if (e.target.classList.contains('modal-trigger') || e.target.getAttribute('href') === '#modal-login') {
      const modal = $(e.target.getAttribute('href'));
      showModal(modal);
    } else if (e.target.classList.contains('modal__close') || e.target.classList.contains('modal__container')) {
      closeModal();
    } 
  })

  document.addEventListener('keydown', (e) => ((e.keyCode || e.which) === 27) && closeModal());

  if (modalWelcom.length == 0) return false;

  let lastDatePopupShowed;
  const lastDateStr = localStorage.getItem('lastDatePopupShowed');
  if (lastDateStr !== null) lastDatePopupShowed = new Date(parseInt(lastDateStr, 10));

  const displayHoursEl = document.getElementById('display_hours');
  let hours = parseInt(displayHoursEl ? displayHoursEl.textContent : '', 10);
  if (isNaN(hours)) hours = 24;

  const urlParams = new URLSearchParams(window.location.search);
  const login = urlParams.get('login');

  if (hours === 0 || (!lastDatePopupShowed || (now - lastDatePopupShowed) >= (hours * 3600000)) && !login) {
    showModal(modalWelcom);
    localStorage.setItem('lastDatePopupShowed', now.getTime());
  }
}

const openResserModal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get('key');
    const login = urlParams.get('login');
    const pass = urlParams.get('pass');

    if(key && login || pass) showModal($('#modal-resset'));
}
    
export {
  triggerModal,
  showModal,
  openResserModal,
}